<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6989_78282)">
      <path
        d="M8.75 20V9.8125L5.5 13.0625L3.75 11.25L10 5L16.25 11.25L14.5 13.0625L11.25 9.8125V20H8.75ZM0 6.25L0 2.5C0 1.8125 0.245 1.22417 0.735 0.735C1.225 0.245833 1.81333 0.000833333 2.5 0L17.5 0C18.1875 0 18.7762 0.245 19.2662 0.735C19.7562 1.225 20.0008 1.81333 20 2.5V6.25L17.5 6.25V2.5L2.5 2.5L2.5 6.25H0Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_6989_78282">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
